import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { FeaturePlanType } from 'api';
import { GroupsWidget, LeaderboardWidget } from 'components';
import {
  useCurrentUser,
  useGroupSearch,
  useProtectedClient,
  useReleases,
  useUserLeaderboards,
} from 'hooks';

import InviteModule from './InviteModule';
import TotalReach from './TotalReach';
import OICTA from './OICTA';

interface Props {
  showInvite: boolean;
  variant: 'primary' | 'secondary';
}

const RightSidebar: FC<Props> = ({ showInvite, variant }) => {
  const { t } = useTranslation();
  const { results } = useGroupSearch({ results_from: 0, size: 3, auto_exclude: true });
  const currentUser = useCurrentUser();
  const userLeaderboards = useUserLeaderboards();
  const releases = useReleases();
  const client = useProtectedClient();

  const leaderboardEnabled = !!userLeaderboards.length;
  const elevation = variant === 'primary' ? 0 : 1;
  const isEnterprise = client.feature_plan_type === FeaturePlanType.E;
  const hasInsights = releases.includes('OrganicInsights') && isEnterprise;

  return (
    <Fragment>
      <Grid marginBottom={2} paddingTop={0}>
        <TotalReach elevation={elevation} />
      </Grid>
      {hasInsights && (
        <Grid marginBottom={2}>
          <OICTA elevation={elevation} />
        </Grid>
      )}
      {leaderboardEnabled && (
        <Grid marginBottom={2}>
          <LeaderboardWidget elevation={elevation} variables={{ user_id: currentUser.id }} />
        </Grid>
      )}
      {showInvite && (
        <Grid marginBottom={2}>
          <InviteModule />
        </Grid>
      )}
      {!!results.length && (
        <Grid marginBottom={2}>
          <GroupsWidget
            elevation={elevation}
            maxResults={3}
            results={results}
            title={t('groups:recommendedGroups')}
          />
        </Grid>
      )}
    </Fragment>
  );
};

export default RightSidebar;
